import type { BrandingTheme } from '../lib/api';
import type { EffectiveTheme } from '../lib/branding';

interface ThemeToggleProps {
  effective: EffectiveTheme;
  onChange: (next: BrandingTheme) => void;
}

// A small icon-only button that flips light ↔ dark. Sets the explicit
// opposite of the currently-active effective theme so a single click always
// produces a visible change, even when the project default was 'auto'.
export default function ThemeToggle({ effective, onChange }: ThemeToggleProps) {
  const next: BrandingTheme = effective === 'dark' ? 'light' : 'dark';
  const label = effective === 'dark' ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <button
      type="button"
      className="auth-theme-toggle"
      aria-label={label}
      title={label}
      onClick={() => onChange(next)}
    >
      {effective === 'dark' ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}

function SunIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}
